module.exports = __webpack_public_path__ + "img/V-45-ST-1000-BB.923b3966.png";